import { Form } from 'antd'
import styled from 'styled-components'

export const FormItem = styled(Form.Item)`
  margin-bottom: 0;
`
